// Fit details drawer on product pages (snippets/fit-guide-product.liquid).
// Mirrors the cart drawer: aria-hidden drives the slide-in, .page-overlay dims the page.
if (!customElements.get('fit-guide-product')) {
  customElements.define('fit-guide-product', class FitGuideProduct extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.drawer = document.getElementById(this.dataset.drawerId);
      this.trigger = this.querySelector('[data-fit-guide-open]');
      if (!this.drawer || !this.trigger) return;
      this.initialized = true;

      // Rendered inside the product form; a fixed drawer belongs at body level, like #cart-drawer.
      document.body.appendChild(this.drawer);

      this.overlay = document.querySelector('.page-overlay');
      this.video = this.drawer.querySelector('video');
      this.onKeyUp = (event) => event.code === 'Escape' && this.close();
      this.onOverlayClick = () => this.close();

      this.trigger.addEventListener('click', () => this.open());
      this.drawer.querySelectorAll('[data-fit-guide-close]').forEach((button) => {
        button.addEventListener('click', () => this.close());
      });
    }

    open() {
      this.drawer.inert = false;
      this.drawer.setAttribute('aria-hidden', 'false');
      this.trigger.setAttribute('aria-expanded', 'true');

      this.overlay?.classList.remove('invisible', 'opacity-0');
      this.overlay?.addEventListener('click', this.onOverlayClick);
      document.addEventListener('keyup', this.onKeyUp);
      document.body.classList.add('overflow-hidden');

      this.drawer.focus();

      if (this.video) {
        this.video.playsInline = true;
        this.video.play().catch(() => {});
      }
    }

    close() {
      if (this.drawer.getAttribute('aria-hidden') === 'true') return;

      this.drawer.setAttribute('aria-hidden', 'true');
      this.drawer.inert = true;
      this.trigger.setAttribute('aria-expanded', 'false');

      this.overlay?.classList.add('invisible', 'opacity-0');
      this.overlay?.removeEventListener('click', this.onOverlayClick);
      document.removeEventListener('keyup', this.onKeyUp);
      document.body.classList.remove('overflow-hidden');

      this.video?.pause();
      this.trigger.focus();
    }
  });
}
